import React from 'react';
import { Steps, Panel, Placeholder, ButtonGroup, Button, Stack } from 'rsuite';
import Bulkstep1 from './Bulkstep1';
import Bulkstep2 from './Bulkstep2';
import Bulkstep3 from './Bulkstep3';
import Bulkstep4 from './Bulkstep4';

const BulkProduct = () => {

    const [step, setStep] = React.useState(0);

  const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
  };

  const onNext = () => onChange(step + 1);
  const onPrevious = () => onChange(step - 1)

  const showstep=(Steps)=>{
    switch (Steps) {
        case 1:
            return < Bulkstep1/>
    
        case 2:
            return <Bulkstep2/>
            
        case 3:
            return <Bulkstep3/>

        case 4:
            return <Bulkstep4/>
    }

  }

    return (
        <>
        <div className='bproduct' style={{'display':'grid'}}>
            <div><ButtonGroup style={{'float':'right','height':'80px'}}>
        {/* <Button onClick={onPrevious} disabled={step === 0}>
          Previous
        </Button> */}
        <Button style={{'color':'white', 'backgroundColor':'#56afa2', 'border':'1px solid #46b1c9', 'width': '150%' }} onClick={onNext} disabled={step === 3}>
          Next
        </Button>
      </ButtonGroup>
      </div>

      <div style={{'marginBottom':'11px', 'marginLeft':'64px'}}>
        <Steps current={step}>
        <Steps.Item title="Upload Images" />
        <Steps.Item title="Group Products"/>
        <Steps.Item title="Add Information" />
        <Steps.Item title="Finish" />
      </Steps>
      <hr style={{'marginTop':'11px', 'marginBottom':'64px'}} />
      <div>{ showstep(step + 1) }
      </div>
      {/* <Panel header={`Step: ${step + 1}`}>
        { showstep(step + 1) }
      </Panel> */}
      
      </div>
      <Stack className="copyright" justifyContent="space-between" style={{'position':'fixed','left':'278px','bottom':'0', 'width':'80%', 'textAlign':'center','backgroundColor':'white'}}>
      <div className="container">
      <p>© All Right Reserved. Product by </p></div><div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        
    </Stack>
        </div>
        </>

    );
};

export default BulkProduct;